// In src/components/devices/DeviceModal.js

import React, { useState, useEffect } from 'react';

const DeviceModal = ({ isOpen, onClose, onSubmit, apiError, properties, deviceToEdit, devices, initialPropertyId }) => {
    const [serialNumber, setSerialNumber] = useState('');
    const [name, setName] = useState('');
    const [propertyId, setPropertyId] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [error, setError] = useState('');

    const isEditMode = !!deviceToEdit;

    useEffect(() => {
        if (isOpen) {
            if (isEditMode) {
                setSerialNumber(deviceToEdit.serial_number || '');
                setName(deviceToEdit.name || '');
                setPropertyId(deviceToEdit.property_id || '');
                setIsActive(!!deviceToEdit.is_active);
            } else {
                // FIX: Reset form for adding a new device and pre-select the property
                setSerialNumber('');
                setName('');
                // FIX: Use the initialPropertyId to pre-select the property
                setPropertyId(initialPropertyId || '');
                setIsActive(true);
            }
            // Clear previous errors when modal opens
            setError('');
        }
    }, [isOpen, deviceToEdit, isEditMode, initialPropertyId]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        // --- Validation ---
        if (!serialNumber || !propertyId) {
            setError('Serial Number and Property are required.');
            return;
        }

        const isDuplicate = devices.some(device =>
            device.serial_number.toLowerCase() === serialNumber.toLowerCase() &&
            device.id !== (deviceToEdit ? deviceToEdit.id : null)
        );

        if (isDuplicate) {
            setError('A device with this Serial Number already exists.');
            return;
        }

        onSubmit({
            serial_number: serialNumber,
            name,
            property_id: propertyId,
            is_active: isActive,
        });
    };

    if (!isOpen) return null;
    
    // FIX: Find the pre-selected property's name for display
    const selectedProperty = properties.find(p => p.id === propertyId);

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{isEditMode ? 'Edit Device' : 'Add New Device'}</h2>
                <form onSubmit={handleSubmit}>
                    {apiError && <div className="form-error-banner">{apiError}</div>}
                    {error && <div className="form-error-banner">{error}</div>}

                    <div className="form-group">
                        <label className="form-label required" htmlFor="dev-sn">Serial Number</label>
                        <input id="dev-sn" type="text" value={serialNumber} onChange={e => setSerialNumber(e.target.value)} className="form-input" required />
                    </div>
                    <div className="form-group">
                        <label className="form-label" htmlFor="dev-name">Device Name (Optional)</label>
                        <input id="dev-name" type="text" value={name} onChange={e => setName(e.target.value)} className="form-input" />
                    </div>
                    <div className="form-group">
                        <label className="form-label required" htmlFor="dev-property">Property</label>
                        {/* FIX: Conditional rendering to show a static field for new devices */}
                        {isEditMode ? (
                            <select id="dev-property" value={propertyId} onChange={e => setPropertyId(e.target.value)} disabled={isEditMode} className="form-input" required>
                                <option value="">Select a Property...</option>
                                {properties.map(prop => (
                                    <option key={prop.id} value={prop.id}>{prop.name}</option>
                                ))}
                            </select>
                        ) : (
                            <div className="form-input static-field">{selectedProperty?.name}</div>
                        )}
                    </div>
                    <div className="form-group">
                         <label className="form-label">Status</label>
                         <div className="toggle-switch-container">
                             <label className="toggle-switch">
                                <input id="dev-active" type="checkbox" checked={isActive} onChange={e => setIsActive(e.target.checked)} />
                                <span className="slider"></span>
                             </label>
                             <span className="toggle-label">{isActive ? 'Active' : 'Inactive'}</span>
                        </div>
                    </div>
                    <div className="modal-actions">
                        <button type="button" onClick={onClose} className="button button-secondary">Cancel</button>
                        <button type="submit" className="button action-button">Save Device</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DeviceModal;